export const CHAT_EASE: [number, number, number, number] = [0.22, 1, 0.36, 1];

export const headerMotion = {
  initial: { opacity: 0, y: -8 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2, ease: CHAT_EASE },
  },
};

export const composerMotion = {
  initial: { opacity: 0, y: 8 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.2, delay: 0.04, ease: CHAT_EASE },
  },
};

export const bubbleMotion = {
  user: {
    initial: { opacity: 0, y: 10, x: 10, scale: 0.985 },
    animate: {
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1,
      transition: { duration: 0.18, ease: CHAT_EASE },
    },
    exit: {
      opacity: 0,
      y: -4,
      scale: 0.985,
      transition: { duration: 0.14, ease: CHAT_EASE },
    },
  },
  patient: {
    initial: { opacity: 0, y: 12, x: -10, scale: 0.985 },
    animate: {
      opacity: 1,
      y: 0,
      x: 0,
      scale: 1,
      transition: { duration: 0.22, ease: CHAT_EASE },
    },
    exit: {
      opacity: 0,
      y: -4,
      scale: 0.985,
      transition: { duration: 0.14, ease: CHAT_EASE },
    },
  },
  hint: {
    initial: { opacity: 0, y: 6, scale: 0.99 },
    animate: {
      opacity: 1,
      y: 0,
      scale: 1,
      transition: { duration: 0.18, ease: CHAT_EASE },
    },
    exit: {
      opacity: 0,
      y: -4,
      scale: 0.99,
      transition: { duration: 0.14, ease: CHAT_EASE },
    },
  },
};

export const typingMotion = {
  initial: { opacity: 0, y: 6 },
  animate: {
    opacity: 1,
    y: 0,
    transition: { duration: 0.18, ease: CHAT_EASE },
  },
  exit: {
    opacity: 0,
    y: 4,
    transition: { duration: 0.14, ease: CHAT_EASE },
  },
};
